import moment from 'moment';
function getEstimatedDeliveryDaysByCountry(countryId) {
    var estimatedDeliveryDays = global.App.estimatedDeliveryDays;
    if (!estimatedDeliveryDays || !estimatedDeliveryDays[String(countryId)]) {
        return null;
    }
    return estimatedDeliveryDays[String(countryId)];
}
function getFormattedEstimatedDeliveryDate(days) {
    return moment().add(days, 'days').format('ll');
}
export var getEstimatedDateFrom = function (shippingCountryId) {
    if (!shippingCountryId) {
        return '';
    }
    var estimatedDeliveryDays = getEstimatedDeliveryDaysByCountry(shippingCountryId);
    if (!estimatedDeliveryDays) {
        return '';
    }
    return getFormattedEstimatedDeliveryDate(estimatedDeliveryDays.from_days);
};
export var getEstimatedDateTo = function (shippingCountryId) {
    if (!shippingCountryId) {
        return '';
    }
    var estimatedDeliveryDays = getEstimatedDeliveryDaysByCountry(shippingCountryId);
    if (!estimatedDeliveryDays) {
        return '';
    }
    return getFormattedEstimatedDeliveryDate(estimatedDeliveryDays.to_days);
};
